import React, { useEffect, useState } from "react";
import {
    Card, CardBody, Row, Col, Button, Table, Input
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { reloadWindowToPath } from "../../Helpers/Utils";

const SaleReturn = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const saleId = location.state?.sale_id;

    const loading = useSelector(state => state.loading.loading);

    const [sale, setSale] = useState(null);
    const [items, setItems] = useState([]);
    const [reason, setReason] = useState("");

    /* ================= LOAD SALE DETAILS ================= */
    const loadSale = async () => {
        if (!saleId) return toast.error("Sale ID missing");

        dispatch(loadingTrue());

        const res = await Handler({
            method: "get",
            url: `/sales/view.php?id=${saleId}`
        });

        dispatch(loadingFalse());

        if (!res?.success) {
            toast.error("Unable to load sale");
            return;
        }

        setSale(res.data.sale);

        setItems(
            res.data.items.map(i => ({
                product_id: i.product_id,
                product_name: i.product_name,
                sold_qty: i.quantity,
                return_qty: 0
            }))
        );
    };

    useEffect(() => {
        loadSale();
        // eslint-disable-next-line
    }, []);

    /* ================= SUBMIT RETURN ================= */
    const submitReturn = async () => {

        const selectedItems = items
            .filter(i => Number(i.return_qty) > 0)
            .map(i => ({
                product_id: i.product_id,
                return_qty: Number(i.return_qty)
            }));

        if (!reason.trim()) {
            toast.error("Return reason required");
            return;
        }

        if (selectedItems.length === 0) {
            toast.error("Select at least one item to return");
            return;
        }

        const payload = {
            sale_id: saleId,
            reason,
            items: selectedItems
        };

        dispatch(loadingTrue());

        const res = await Handler({
            method: "post",
            url: "/sales/return.php",
            data: payload
        });

        dispatch(loadingFalse());

        if (!res?.success) {
            toast.error(res?.message);
            setTimeout(() => {
                reloadWindowToPath('/pos-list')
            }, 2000)
            return;
        }
        toast.success(`Refund ₹${res.data.refund_amount}`);
        setTimeout(() => {
            reloadWindowToPath('/return-list')
        }, 1000)
    };

    /* ================= UI ================= */
    return (
        <React.Fragment>
            <Row className="mb-3">
                <Col><h5 className="fw-bold">Return Product</h5></Col>
            </Row>
            <Row>
                <Col md={10} className="mx-auto">
                    <Card className="shadow-sm">
                        <CardBody>

                            <h5 className="fw-bold mb-3">
                                Return Sale #{saleId}
                            </h5>

                            {sale && (
                                <div className="mb-3 text-muted">
                                    Customer: {sale.customer_name || "Walk-in"} <br />
                                    Invoice: {sale.invoice_no}
                                </div>
                            )}

                            {/* ================= ITEMS ================= */}
                            <Table bordered>
                                <thead className="table-light">
                                    <tr>
                                        <th>Product</th>
                                        <th className="text-center">Sold Qty</th>
                                        <th className="text-center">Return Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((i, idx) => (
                                        <tr key={idx}>
                                            <td>{i.product_name}</td>
                                            <td className="text-center">{i.sold_qty}</td>
                                            <td className="text-center">
                                                <Input
                                                    type="number"
                                                    min="0"
                                                    max={i.sold_qty}
                                                    value={i.return_qty}
                                                    onChange={e => {
                                                        const val = Math.min(
                                                            Number(e.target.value),
                                                            i.sold_qty
                                                        );
                                                        setItems(prev => {
                                                            const copy = [...prev];
                                                            copy[idx].return_qty = val;
                                                            return copy;
                                                        });
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            {/* ================= REASON ================= */}
                            <Row className="mb-3">
                                <Col>
                                    <Input
                                        type="textarea"
                                        placeholder="Return reason"
                                        value={reason}
                                        onChange={e => setReason(e.target.value)}
                                    />
                                </Col>
                            </Row>

                            {/* ================= ACTIONS ================= */}
                            <Row>
                                <Col className="text-end">
                                    <Button disabled={loading} color="success" className="me-2"
                                        onClick={() => navigate(-1)}>
                                        Cancel
                                    </Button>
                                    <Button disabled={loading} color="danger"
                                        onClick={submitReturn}>
                                        Confirm Return
                                    </Button>
                                </Col>
                            </Row>

                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default SaleReturn;
